// extracted by mini-css-extract-plugin
export default {"social-links":"styles_social-links__jYLb8","social-links--icons":"styles_social-links--icons__+gXi4"};